import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBaseball } from '@fortawesome/free-solid-svg-icons';

const Logo = ({ size = '2x', isDarkMode }) => {
  return (
    <div style={{ color: isDarkMode ? '#ffffff' : '#002B5C' }}> {/* White in dark mode, Twins Navy Blue in light mode */}
      <FontAwesomeIcon icon={faBaseball} size={size} style={{ transform: 'rotate(-20deg)' }} />
    </div>
  );
};

export default Logo;
